import { j as a } from "../../../../jsx-runtime-B3iL8JI7.js";
import i from "../Button.js";
import o from "../../../../utilities/tw.js";
import p from "../../../../tailwindConfig/bclTwMerge.js";
const j = ({
  children: s,
  className: e = "",
  iconName: r,
  variant: t,
  ...m
}) => {
  const c = o`size-12 px-4 text-lg`, l = o`p-0`, n = p(
    c,
    t === "ghost" && l,
    e
  );
  return /* @__PURE__ */ a.jsx(
    i,
    {
      "aria-label": r,
      className: n,
      variant: t,
      ...m,
      children: s
    }
  );
};
export {
  j as default
};
